import { useSelector } from "react-redux";
import TaxesFeesInfo from "./TaxesFeesInfo";
import { getTotalExcludedTaxes } from "app/pages/Booking/bookingSelectors";

const TaxesFeesInfoContainer = () => {
	const totalExcludedTaxes = useSelector(getTotalExcludedTaxes);
	return <TaxesFeesInfo amount={totalExcludedTaxes} />;
};

export default TaxesFeesInfoContainer;
